import React from "react";
import Phonetics from "./Phonetics";
import Synonyms from "./Synonyms";
import Definitions from "./RDefinitions";

export default function Dictionary(props) {
  //console.log(props.wordInfo);
  return (
    <div className="results">
      <Phonetics word={props.choseWord} otherInfo={props.wordInfo} />

      {props.wordInfo.syn.map(function (info, index) {
        return (
          <div key={index}>
            <Synonyms info={info} choseWord={props.choseWord} />
          </div>
        );
      })}

      {props.wordInfo.information.map(function (information, index) {
        return (
          <div key={index}>
            <Definitions
              definitions={information}
              currentWord={props.currentWord}
            />
          </div>
        );
      })}
    </div>
  );
}
